export default __webpack_public_path__ + "static/media/thinking_face.9bc78cc2.png";